'use client';

import styled from '@emotion/styled';
import { useEffect, useMemo } from 'react';
import { SectionDesign, SectionPosition } from '@diritto/common/home/constants/section-constants';
import { TrackerExtraInfo, TrackerPosition, TrackingEventType } from '@diritto/common/tracker/tracking-event.constant';
import { useGetSectionsQuery } from '@/queries/relay/useGetSectionsQuery';
import { Section } from 'app-components/home/sections/Section';
import { FooterHeight, GNBHeight, isPC, MobileGNBMenuHeight, PageContentBottomMargin } from 'constants/layout';
import { useAuthState } from 'contexts/AuthProvider';
import { useHomeSettingState } from 'contexts/HomeSettingProvider';
import { useTrackingState } from 'contexts/TrackingProvider';
import { ArrowDoubleDownIcon } from 'icons/ArrowDoubleDownIcon';
import { Loading } from 'ui-components/common/Loading';
import { ModeGuideFAB } from 'ui-components/common/ModeGuideFAB';
import { useRootPageModal } from 'ui-hooks/useRootPageModal';

const trackerExtraInfo: TrackerExtraInfo = {
  trackerPosition: TrackerPosition.Home,
};

export const HomeRootPage = () => {
  const { partner } = useAuthState();
  const { categoryIds } = useHomeSettingState();
  const { tracker } = useTrackingState();

  useRootPageModal();

  useEffect(() => {
    tracker.track(TrackingEventType.ViewHome);
  }, [tracker]);

  const { data, isLoading } = useGetSectionsQuery({
    includeAdult: true,
    position: SectionPosition.Home,
    categoryIds,
  });

  const filteredSections = useMemo(() => {
    if (partner) {
      return data?.sections.filter(section => section.design !== SectionDesign.QuickMenu);
    }

    return data?.sections;
  }, [data?.sections, partner]);

  if (isLoading) {
    return (
      <StyledLoading>
        <Loading />
      </StyledLoading>
    );
  }

  return (
    <>
      <div className="flex flex-col gap-8 pt-4 min-h-screen">
        {data &&
          filteredSections &&
          filteredSections.map(section => (
            <Section
              key={section.id}
              section={section}
              contents={data.contents || {}}
              episodes={data.episodes || {}}
              profileLites={data.profileLites || {}}
              replies={data.replies || {}}
              fancyShares={data.fancyShares || {}}
              rollings={data.rollings || {}}
              trackerExtraInfo={trackerExtraInfo}
            />
          ))}
      </div>
      <ModeGuideFAB>
        <span className="text-white text-xxxs font-bold">홈 보기 방식을 바꿔보세요!</span>
        <ArrowDoubleDownIcon className="size-[14px]" />
      </ModeGuideFAB>
    </>
  );
};

const StyledLoading = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: calc(100vh - ${GNBHeight}px - ${MobileGNBMenuHeight}px - ${PageContentBottomMargin}px - ${FooterHeight}px);

  @media (${isPC}) {
    height: 100%;
  }
`;
